import * as React from 'react';
import styles from './index.less';
import FResourceStatusBadge from '../FResourceStatusBadge';
import FCoverImage from '@/components/FCoverImage';
import FCoverFooterButtons from '@/components/FCoverFooterButtons';
import FTooltip from '@/components/FTooltip';
import FComponentsLib from '@freelog/components-lib';
import { FI18n, FUtil } from '@freelog/tools-lib';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import { MouseEventHandler } from 'react/index';
import FIcons from '@/components/FIcons';

type EventFunc = () => void;

export interface FResourceCardProps {
  className?: string;
  type?: 'resource' | 'favorite' | 'market';
  showUserInfo?: boolean;
  resource: {
    id: string;
    cover: string;
    name: string;
    title: string;
    version: string;
    policy: string[];
    type: string[];
    status: 0 | 1 | 2 | 4;
    authProblem?: boolean;
    updateDate: string;
    username: string;
    useAvatar: string;
    isChoice: boolean;
    collection?: {
      status: 'finish' | 'unFinish';
      count: number;
    } | null;
  };
  onBoomJuice?: EventFunc;
  onClickDetails?: EventFunc;
  onClickEditing?: EventFunc;
  onClickRevision?: EventFunc;
  // onClickMore?: EventFunc;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

function FResourceCard({
  className = '',
  type = 'market',
  resource,
  onBoomJuice,
  onClickDetails,
  onClickEditing,
  onClickRevision,
  onClick,
  showUserInfo = true,
}: // collection,
FResourceCardProps) {
  return (
    <div
      onClick={(event) => {
        onClick && onClick(event);
      }}
      className={[styles.styles, className, type === 'market' ? styles.gesture : ''].join(' ')}
    >
      <div className={styles.Cover}>
        <FCoverImage src={resource.cover} width={280} style={{ borderRadius: 4 }} />
        {type !== 'market' && (
          <>
            {!!resource.collection && (
              <label className={styles.collectionLabel}>
                <div>{FI18n.i18nNext.t('resource_card_collection_subject')}</div>
                <div
                  style={{
                    border: '1px solid #FFFFFF',
                    opacity: 0.2,
                    height: 10,
                  }}
                />
                <div>
                  {resource.collection.status === 'finish'
                    ? '已完结'
                    : // : '连载中'
                      FI18n.i18nNext.t('cqr_itemmgmt_updatestates_ongoing')}
                </div>
                <div
                  style={{
                    border: '1px solid #FFFFFF',
                    opacity: 0.2,
                    height: 10,
                  }}
                />
                <div>
                  {FI18n.i18nNext.t('resource_card_collection_itemcount', {
                    itemCount: resource.collection.count,
                  })}
                </div>
              </label>
            )}

            <nav className={styles.CoverMask}>
              {type === 'favorite' ? (
                <FCoverFooterButtons
                  buttons={[
                    {
                      type: 'resourceDetails',
                      fn() {
                        onClickDetails && onClickDetails();
                      },
                    },
                    {
                      type: 'cancelCollect',
                      fn() {
                        onBoomJuice && onBoomJuice();
                      },
                    },
                  ]}
                />
              ) : (
                <FCoverFooterButtons
                  buttons={[
                    {
                      type: 'resourceDetails',
                      fn() {
                        onClickDetails && onClickDetails();
                      },
                    },
                    {
                      type: 'edit',
                      fn() {
                        onClickEditing && onClickEditing();
                      },
                    },
                    {
                      type: 'update',
                      fn() {
                        onClickRevision && onClickRevision();
                      },
                    },
                  ]}
                />
              )}
            </nav>
            <div className={styles.Status}>
              <FResourceStatusBadge
                status={
                  resource.status === 2
                    ? 'freeze'
                    : resource.status === 1
                    ? 'online'
                    : resource.status === 0
                    ? 'unreleased'
                    : 'offline'
                }
              />

              {resource.authProblem && (
                <FTooltip
                  // title={'存在授权问题'}
                  title={FI18n.i18nNext.t('alert_resource_no_auth')}
                >
                  <FIcons.FWarning style={{ fontSize: 16 }} />
                </FTooltip>
              )}

              {resource.isChoice && (
                <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                  <img src={img_choiceLabel} alt={''} style={{ width: 24, height: 24 }} />
                </FTooltip>
              )}
            </div>
          </>
        )}

        {type === 'market' && resource.isChoice && (
          <>
            <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
              <img
                src={img_choiceLabel}
                alt={''}
                style={{
                  width: 24,
                  height: 24,
                  position: 'absolute',
                  top: 10,
                  left: 10,
                }}
              />
            </FTooltip>
          </>
        )}

        {type === 'market' && !!resource.collection && (
          <label className={styles.collectionLabel} style={{ bottom: 10 }}>
            <div>{FI18n.i18nNext.t('resource_card_collection_subject')}</div>
            <div
              style={{
                border: '1px solid #FFFFFF',
                opacity: 0.2,
                height: 10,
              }}
            />
            <div>
              {resource.collection.status === 'finish'
                ? // '已完结'
                  FI18n.i18nNext.t('cqr_itemmgmt_updatedstates_completed')
                : // : '连载中'
                  FI18n.i18nNext.t('cqr_itemmgmt_updatestates_ongoing')}
            </div>
            <div
              style={{
                border: '1px solid #FFFFFF',
                opacity: 0.2,
                height: 10,
              }}
            />
            <div>
              {FI18n.i18nNext.t('resource_card_collection_itemcount', {
                itemCount: resource.collection.count || 0,
              })}
            </div>
          </label>
        )}
      </div>
      <div style={{ height: 10 }} />
      <FComponentsLib.FContentText
        singleRow={true}
        text={resource.title || resource.name.split('/')[1]}
        type={'highlight'}
        style={{ maxWidth: 280 }}
      />
      <div style={{ height: 5 }} />
      <FComponentsLib.FContentText
        type='additional2'
        text={FUtil.Format.resourceTypeKeyArrToResourceType(resource.type)}
        style={{ maxWidth: 280 }}
        singleRow
      />
      <div style={{ height: 5 }} />
      <FComponentsLib.FContentText
        singleRow
        style={{ maxWidth: 280 }}
        type='additional2'
        // text={`最新更新时间 ${resource.updateDate}`}
        text={FI18n.i18nNext.t('resource_card_label_lastupdated', {
          LatestUpdatedTime: resource.updateDate,
        })}
      />
      <div style={{ height: 5 }} />
      <div className={styles.policy}>
        {resource.policy.length > 0 ? (
          // ? resource.policy.map((i: string) => <Policy key={i} text={i} />)
          <FComponentsLib.F_Contract_And_Policy_Labels
            data={resource.policy.map((p) => {
              return {
                text: p,
                dot: '',
              };
            })}
            singleRow
          />
        ) : (
          <FComponentsLib.FContentText
            //  text={'暂无策略…'}
            text={FI18n.i18nNext.t('resource_card_msg_noplans')}
            type='additional2'
          />
        )}
      </div>
      {showUserInfo && (
        <>
          <div style={{ height: 12 }} />
          <div className={styles.user}>
            <img src={resource.useAvatar || img_choiceLabel} alt={''} />
            <span>{resource.username}</span>
          </div>
        </>
      )}
    </div>
  );
}

export default FResourceCard;
